import './App.css';

import Pdf from './documents/Resume.pdf';
import Email from './assets/Email.png';
import Github from './assets/Github.png';
import Linkedin from './assets/Linkedin.png';
import Logo from './assets/Logo.png';

import About from './sections/About';
import Banner from './sections/Banner';
import Experiences from './sections/Experiences';
import Projects from './sections/Projects';
function App() {
  
  const handleClickScroll = (section) => {
    const element = document.getElementById(section);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="App">
      <header className='App-header'>
        <div className='Centered max-height'>
          <button 
            style={{border: 'none', backgroundColor: 'white'}}
            onClick={() => handleClickScroll("section-0")}
          >
            <img className='Title' src={Logo} alt='Sangwook Lee'/>
          </button>
          <div className="Menu">
            <button onClick={() => handleClickScroll("section-1")}>About</button>
            <button onClick={() => handleClickScroll("section-2")}>Experiences</button>
            <button onClick={() => handleClickScroll("section-3")}>Projects</button>
            <button onClick={() => handleClickScroll("section-4")}>Contacts</button>
            <a href={Pdf}>Resume</a>
          </div>
        </div>
      </header>
      <Banner id='section-0'/>
      <About id='section-1'/>
      <Experiences id='section-2'/>
      <Projects id='section-3'/>
      <div id='section-4' className='Contacts'>
        <div className='Header White'>
          CONTACTS
        </div>
        <div className='Section'>
          <div className='Contact'>
            <div className='Icon' style={{ backgroundImage: `url(${Email})`}}></div>
            leesangwook4517@gmail.com
          </div>
          <div className='Contact'>
            <div className='Icon' style={{ backgroundImage: `url(${Linkedin})`}}></div>
            https://www.linkedin.com/in/lee-sangwook/
          </div>
          <div className='Contact'>
            <div className='Icon' style={{ backgroundImage: `url(${Github})`}}></div>
            https://github.com/SSonagi
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
